
import React from 'react';
import styled from 'styled-components';
import { media } from 'utils/style';
import PropTypes from 'prop-types';
import FranceFlag from 'assets/icons/xpo/flags/flag_france.svg';
import RomaniaFlag from 'assets/icons/xpo/flags/flag_romania.svg';
import PolandFlag from 'assets/icons/xpo/flags/flag_poland.svg';
import SpainFlag from 'assets/icons/xpo/flags/flag_spain.svg';


const CountryContactContainer = styled.div`
  display: block;
  width: 400px;
  height: 40px;
  border-bottom: 1px solid var(--grey300);
  padding: 10px 8px 0px 8px;
  margin: auto;
  white-space: nowrap;
  ${media.lessThan('extraSmall')`
    width: 100%;
  `};
`;

const CountryContactFlag = styled.div`
  display: inline-block;
  width: 22px;
  height: 16px;
  background-image: url(${props => (props.flag)});
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: -2px;
  margin-right: 4px;
`;

const CountryContactNumber = styled.a`
  display: inline-block;
  color: var(--grey700);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 150px;
  text-align: left;
  margin-left: 12px;
  text-decoration: none;
  &:hover {
      text-decoration: underline;
    }
  ${media.lessThan('extraSmall')`
    margin-left: 8px;
    width: 115px;
  `};
`;

const CountryContactMail = styled.a`
  display: inline-block;
  color: var(--grey700);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 180px;
  text-align: left;
  margin-left: 12px;
  text-decoration: none;
  &:hover {
      text-decoration: underline;
    }
  ${media.lessThan('extraSmall')`
    margin-left: 8px;
    width: 155px;
  `};
`;

export const CountryContactRow = ({ flag, number, mail }) => {
    return (
      <CountryContactContainer>
        {flag === "FR" ? <CountryContactFlag flag={FranceFlag} /> : null}
        {flag === "RO" ? <CountryContactFlag flag={RomaniaFlag} /> : null}
        {flag === "PL" ? <CountryContactFlag flag={PolandFlag} /> : null}
        {flag === "ES" ? <CountryContactFlag flag={SpainFlag} /> : null}
        <CountryContactNumber href={`tel:${number}`}>{number}</CountryContactNumber>
        <CountryContactMail href={`mailto:${mail}`}>{mail}</CountryContactMail>
      </CountryContactContainer>
    );
  };
  
CountryContactRow.propTypes = {
    flag: PropTypes.string,
    number: PropTypes.string,
    mail: PropTypes.string,
  };
  
CountryContactRow.defaultProps = {
    flag: '',
    number: '',
    mail: '',
  };